// YouTube helpers: build the embed and thumbnail URLs from a video ID.

/**
 * Build the iframe embed URL. Defaults to the no-cookie host.
 *
 * @param {string} videoId - the 11-char video ID
 * @param {object} [opts] - embed options
 * @param {boolean} [opts.cookies] - use the standard youtube.com host
 * @param {boolean} [opts.autoplay] - autoplay (only works after a user gesture)
 * @returns {string} the iframe src URL
 */
export const buildEmbedUrl = (videoId, opts = {}) => {
    const host = opts.cookies
        ? 'https://www.youtube.com'
        : 'https://www.youtube-nocookie.com';

    const params = new URLSearchParams({
        playsinline: '1', // stops iOS forcing fullscreen
        modestbranding: '1',
        rel: '0'
    });

    if (opts.autoplay) {
        params.set('autoplay', '1');
    }

    return `${host}/embed/${videoId}?${params.toString()}`;
};

/**
 * Thumbnail URL. `maxresdefault` is sharp but 404s without an HD source; fall back to `hqdefault`.
 *
 * @param {string} videoId - the 11-char video ID
 * @param {string} [quality] - 'maxresdefault' (default) or 'hqdefault'
 * @returns {string} thumbnail image URL
 */
export const buildThumbnailUrl = (videoId, quality = 'maxresdefault') =>
    `https://img.youtube.com/vi/${videoId}/${quality}.jpg`;
